// extracted by mini-css-extract-plugin
module.exports = {"history":"history--9GUcL","title":"title--+lfFs","bordered":"bordered--VmFVn","list":"list--HMnTN","listDark":"listDark--i9ZqC"};